export default () => ({
  card: {
    width: '100%',
    marginBottom: '1rem',
  },
  defaultStartingStatusContainer: { display: 'flex' },
  accordionSummary: { alignItems: 'center' },
  statusName: {
    flex: 1,
    marginLeft: 16,
  },
  accordionRoot: { '&:before': { content: 'unset' } },
});
